import { addIndex, map } from 'ramda';

export const mapIndex = addIndex(map);
